module.exports = __webpack_public_path__ + "media/images/kds/settings-934ab95c7921cafbaaa5d9347706b615.svg";